<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>热门招标</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="main">
      <div class="main_top">
        <el-form
          ref="sizeForm"
          label-width="80px"
          :model="sizeForm"
          class="nextPart"
        >
          <el-form-item label="送货地区" prop="area">
            <el-cascader
              style="width: 100%"
              v-model="sizeForm.area"
              ref="area"
              class="projectAddress"
              placeholder="公司所在地"
              :props="{ checkStrictly: true }"
              :options="getprovince"
              @change="areaHandleChange"
            >
            </el-cascader>
          </el-form-item>
        </el-form>
        <div class="search">
          <el-input
            v-model="sizeForm.title"
            placeholder="请输入招标标题"
            class="ipt"
            @keyup.enter.native="handleSearch()"
          ></el-input>
          <button class="btn" @click="handleSearch()">查询</button>
        </div>
      </div>
      <div class="main_content">
        <template>
          <el-table
            :header-cell-style="headClass"
            :data="tableData"
            style="width: 100%"
            :default-sort="{ prop: 'starttime', order: 'descending' }"
            @sort-change="handleSortChange"
          >
            <el-table-column prop="code" label="招标单编号" width="200">
            </el-table-column>
            <el-table-column prop="title" label="招标标题" width="150">
            </el-table-column>
            <el-table-column prop="address" label="送货地址" width="180">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="发布时间"
              width="200"
              sortable
            >
            </el-table-column>
            <!-- <el-table-column
              prop="quoteEndTime"
              label="最迟报价时间"
              width="180"
            >
            </el-table-column> -->
            <el-table-column label="报价倒计时" align="center"  width="180">
              <template slot-scope="scope">
                <flipDown
                  :endDate="`${new Date(scope.row.quoteEndTime).getTime()}`"
                  :timeUnit="timeUnit"
                />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button

                  v-if="scope.row.status !== 5"
                  class="pricebtn"
                  @click="handleQuotedPrice(scope.row, scope.$index)"
                >
                <!-- invitationStatus  邀约状态(0未邀约 1邀约)-->
                <span v-if="scope.row.hasQuoted==1&&scope.row.invitationStatus==1">再次报价</span>
               <span v-else>我的报价</span>  
                </el-button>

                <el-button
                  v-if="scope.row.status == 5"
                  class="pricebtn"
                  @click="handleorder(scope.row, scope.$index)"
                >
                  已中标
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <el-row>
          <el-col :span="24" class="pagination">
            <!-- 分页组件 -->
            <Pagination
              v-bind:child-msg="pageparm"
              @callFather="callFather"
            ></Pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import { mapState, mapMutations } from "vuex";
import { releaselist, listForSupplier } from "@/api/xunyou";
import flipDown from "vue-flip-down";
export default {
  data() {
    return {
       loading:true,
      sizeForm: {
        area: "",
        code: "",
        supplierId: JSON.parse(localStorage.getItem("userdata")).bxmId,
        title: "",
        pageSize: 10,
        pageNum: 1,
      },
      timeUnit: ["天", ":", ":", ""],
      tableData: [],
      // 分页参数
      pageparm: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
    };
  },
  created() {
    this.handleData();
  },
  // 注册组件
  components: { Pagination, flipDown },
  computed: {
    ...mapState(["getprovince"]),
  },
  methods: {
    //获取数据
    handleData() {
      this.loading=false
      listForSupplier(this.sizeForm).then((res) => {
        if (res.code == 0) {
          this.pageparm.total = res.total;
          this.tableData = res.rows;
        }
      });
    },
    //查询
    handleSearch() {
      this.handleData();
      this.$nextTick(() => {
        this.sizeForm.area = "";
        this.sizeForm.title = "";
      });
    },
    // 公司地址选择
    areaHandleChange(value) {
      this.$refs["area"].getCheckedNodes();
      this.sizeForm.area = value[value.length - 1];
    },
    // 表头样式设置
    headClass() {
      return "background:#eef1f6;color:black";
    },
    //立即报价
    keyQuotedPrice(item, index) {
      console.log(11);
      this.$router.push(`/procurementDetails?id=${item.id}&code=${item.code}`);
    },
    handleQuotedPrice(item, index) {
      // hasQuoted==1 修改报价 2为立即报价
      this.$router.push(`/procurementDetails?id=${item.id}&code=${item.code}&hasQuoted=${item.hasQuoted}`);
    },
    handleorder(item, index) {
      this.$router.push(
        `/SupplierQuotation?id=${item.id}&code=${item.code}&status=${item.status}`
      );
    },
    //排序改变
    handleSortChange(column, prop, order) {
      console.log(column, prop, order, "val");
    },
    // 分页插件事件
    callFather(parm) {
      this.sizeForm.pageNum = parm.currentPage;
      this.sizeForm.pageSize = parm.pageSize;
      this.handleData(this.sizeForm);
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  background-color: white;
  padding: 20px;
}
.main_top {
  display: flex;
  justify-content: space-between;
  border-bottom: 2.5px dotted #e3e3e3;
  .search {
    display: flex;
    .ipt {
      outline: none;
    }
    .btn {
      color: white;
      font-size: 14px;
      border: none;
      border-radius: 0 4px 4px 0;
      width: 80px;
      height: 40px;
      line-height: 20px;
      background-color: #c65442;
      padding: 10px;
    }
  }
}
.main_content {
  margin-top: 30px;
  .pricebtn {
    border: 1px solid #c65442;
    color: #c65442;
  }
}
.pagination {
  text-align: right;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #c65442;
    color: #fff;
    width: 20px;
  }
  /deep/.el-pagination.is-background .btn-next,
  /deep/.el-pagination.is-background .btn-prev,
  /deep/.el-pagination.is-background .el-pager li {
    width: 20px;
  }
  /deep/input[disabled],
  input[disabled="disabled"],
  input[readonly],
  input[readonly="readonly"] {
    background-color: transparent;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/procurementTenders/procurementList.vue